<template>
  <a-row type="flex" class="attachable-show-component">
    <a-col flex="auto">
      <AttachableTypeComponent :attachable="attachable"></AttachableTypeComponent>
      <a :href="showLink" target="_blank" v-on:click.stop v-if="canShow">
        {{ name }}
      </a>
      <span v-else>
      {{ name }}
    </span>
    </a-col>
    <a-col flex="auto">
      {{ date }}
    </a-col>
    <a-col flex="auto">
      <HumanFilesizeComponent :bytes="size"></HumanFilesizeComponent>
    </a-col>
  </a-row>
</template>

<script>
import AttachableTypeComponent from '~/components/FileTypeIconComponent';
import HumanFilesizeComponent from '~/components/HumanFilesizeComponent';

const moment = require('moment');

export default {
  name: "AttachableShowComponent",
  props: {
    attachable: {
      type: Object,
      required: true
    }
  },
  components: {
    AttachableTypeComponent,
    HumanFilesizeComponent
  },
  data() {
    return {
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
    }
  },
  computed: {
    childInstance() {
      return this.attachable.child_instance.data;
    },
    name() {
      return this.childInstance.name;
    },
    date() {
      return moment(this.childInstance.date, moment.ISO_8601).format('D/MM/YYYY HH:mm:ss');
    },
    size() {
      return this.childInstance.size;
    },
    canShow() {
      return typeof this.childInstance.show_link !== "undefined";
    },
    showLink() {
      return this.childInstance.show_link;
    }
  },
}
</script>

<style scoped>

.attachable-show-component {
  padding: 15px 10px;
  border: solid 1px #ccc;
  border-radius: 4px;
}

</style>
